import React, { useState, useEffect } from 'react';
import '../../../assets/css/donor/dashboard/AllNotifications.css';
import DonorLayout from "../../../layouts/donor/DonorLayout";

const AllNotifications = () => {

  const [activeTab, setActiveTab] = useState('all');
  const [notifications, setNotifications] = useState([]);

  // ✅ Load from localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("notifications")) || [];
    setNotifications(stored);
  }, []);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const filteredNotifications = notifications.filter((n) => {
    if (activeTab === 'unread') return !n.isRead;
    if (activeTab === 'read') return n.isRead;
    return true;
  });

  // ✅ Mark all
  const markAllAsRead = () => {
    const updated = notifications.map(n => ({ ...n, isRead: true }));
    setNotifications(updated);
    localStorage.setItem("notifications", JSON.stringify(updated));
  };

  return (
    <DonorLayout>
      <div className="donor-notifications-container">

        <div className="donor-notifications-header">
          <div>
            <h2 className="donor-notifications-title">Notifications</h2>
            <p className="donor-notifications-subtitle">
              You have {unreadCount} unread notifications
            </p>
          </div>

          <button className="donor-mark-read-btn" onClick={markAllAsRead}>
            Mark all as read
          </button>
        </div>

        <div className="donor-notifications-tabs">
          <button
            className={activeTab === 'all' ? 'active' : ''}
            onClick={() => setActiveTab('all')}
          >
            All ({notifications.length})
          </button>

          <button
            className={activeTab === 'unread' ? 'active' : ''}
            onClick={() => setActiveTab('unread')}
          >
            Unread ({unreadCount})
          </button>

          <button
            className={activeTab === 'read' ? 'active' : ''}
            onClick={() => setActiveTab('read')}
          >
            Read ({notifications.length - unreadCount})
          </button>
        </div>

        <div className="donor-notifications-list">
          {filteredNotifications.map((item) => (
            <div
              key={item.id}
              className={`donor-notifications-card ${!item.isRead ? 'unread' : ''}`}
            >
              <div className="donor-notifications-card-header">
                <h4>{item.title}</h4>
                <span>{item.time}</span>
              </div>
              <p>{item.message}</p>

              {!item.isRead && <span className="donor-unread-badge">New</span>}
            </div>
          ))}
        </div>

      </div>
    </DonorLayout>
  );
};

export default AllNotifications;